// extracted by mini-css-extract-plugin
export default {"header":"Header_header__bHvxf","main-image":"Header_main-image__6XzLl"};